import React from 'react';
import { Select } from 'antd';
import services from "../../services";
import { Button } from '@progress/kendo-react-buttons'
import $ from 'jquery'
import { Input } from "@progress/kendo-react-inputs"
import queryString from "query-string"

const { Option } = Select;

class CreateIntroduzirRef extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         popUpForm: '',
         data: [],
         idEntidade: 0,
         idContaCorrente: 0,
         idContaCorrenteMovimento: 0,
         idTipoMovimento: 0,
         valorOp: 0,
         instalacaoVinica: "",
         tipoConta: "",
         produto: "",
         quantidade: "",
         tipoMovimento: "",
         entidade: "",
         instalacoesVinicasDestino: [],
         idInstalacaoVinicaDestino: 0,
         idContaCorrenteDestino: 0,
         contasCorrentesDestino: [],
         contasExecuted: 0
      }
   }

   /* Esta é a primeira etapa após o construxctor para carregar este componente  */

   componentDidMount() {

   }

   handleFechar = () => {
      $(".left-popup").trigger('click');
      window.location.reload(false);
   }

//    handleChangeConta = (e) => {
//       this.setState({ idContaCorrenteDestino: e });
//    }

//    handleSubmit = async (e) => {
//       e.preventDefault()
      
//       ;(async () => {
         
//          const queryParams = queryString.parse(this.props.location.search)

//          const params = {
//             IDEntidade: +queryParams.entityId,
//             NumeroAT: 0,
//             NumeroDA: 0,
//             ValorTransporte: 0,
//             LoggedUser: window.localStorage.getItem('username'),
//             IDContaCorrenteMovimento: 0,
//             Transportador: 0,
//             MeioTransporte: 0,
//             Matricula: 0,
//             NomeSignatario: 0,
//             TelSignatario: 0,
//          }

//          console.log("SEND PARAMS");
//          console.log(params);

//          const response = await services.apiCall.requestApi(
//             "ContaCorrente/CriarDocumento",
//             params,
//             "post"
//          )
//          if(response){
//             this.handleFechar()
//          }
//          else{
//             this.handleFechar()
//          }
      
//       })()
//    }

   render() {
      return (
         <div className="modal-content" style={{width: "25%",}}>
            <div className="modal-header">
               <h4 className="modal-title pl-0">Referência do eDA</h4>
               <Button onClick={() => this.handleFechar()} primary={true} className="remoove btn-ivdp-primary cursor-pointer mr-2">Fechar</Button>
            </div>
            <div className="modal-body">
               <div className="form-group position-relative">
                  {/* <h5>Transporte:</h5> */}
                  <div className="row">
                     <div className="col-md-12">
                        <div className="input-box active-grey">
                           <Input
                              style={{
                                 width: "100%",
                              }}
                              className="input-1"
                              name="RefEDA"
                              //placeholder="Transportador"
                              label="Referência do eDA"
                              //onChange={(e) => this.handleChange(e)}
                           />
                        </div>
                     </div>
                  </div>
                  <div className="col-md-12 mt-4 p-0">
                     <button
                        className="k-button k-primary btn-ivdp-primary btn-sm"
                        type="submit"
                        //onClick={this.handleSubmit}
                     >
                        Efetuar Operação
                     </button>
                     <button
                        className="k-button mr-2 k-primary btn-ivdp-secondary btn-theme remoove ml-2 text-danger"
                        onClick={() => this.handleFechar()}
                     >
                        Cancelar
                     </button>
                  </div>
               </div>  
            </div>
         </div>
      )
   }
}

export default CreateIntroduzirRef;